export default function Facebook({ isHover }) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill={isHover ? '#fff' : '#292929'} />
      <path
        d="M17.7287 30H21.5744V20.4187H24.79L25.2756 16.6913H21.5744V14.3025C21.5744 13.2263 21.8763 12.4912 23.425 12.4912H25.4069V9.14437C25.0656 9.105 23.8975 9 22.5325 9C19.6712 9 17.7287 10.7456 17.7287 13.935V16.6913H14.5V20.4187H17.7287V30Z"
        fill={isHover ? '#121212' : '#F6F6F6'}
      />
    </svg>
  );
}
